import { MaxWidthContainer } from "@cmde/shadcn";

export default function PageLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex w-full flex-1 flex-col">
      <main className="flex-1">
        <MaxWidthContainer>
          <div className="pb-6 pt-5">{children}</div>
        </MaxWidthContainer>
      </main>
    </div>
  );
}
